var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -6327.3423,
    y1: -5520.4067,
    x2: -6674.4966,
    y2: -5224.8315,
    gradientTransform: "matrix(-0.652 -0.7583 0.7583 -0.652 366.0781 -7713.9448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D73FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    style: {
      stopColor: "#4B72FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6431,
    style: {
      stopColor: "#4471FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7645,
    style: {
      stopColor: "#396DF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8627,
    style: {
      stopColor: "#2868F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9457,
    style: {
      stopColor: "#1262EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#005DE6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M340.4,458.9c3.8,0.4,7.7,0.7,11.5,1.1c83,8,166.2,15,248.8,26.2c15.6,62.6,25.7,116,39.7,145 c38.2,78.8,110.7,50.9,131.6,18.4c-5.5,14.9-11,29.8-16.5,44.7c-18.9,51-37.9,101.8-56.5,152.9c-21.6,59.4-61.4,130.8-136.3,119 c-64.5-10.1-89.9-81.3-106-135.9c-27.4-92.7-44.4-186.6-76.3-278C369.4,520.7,356,489.3,340.4,458.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -6428.3247,
    y1: -5235.7256,
    x2: -6583.1782,
    y2: -5103.8799,
    gradientTransform: "matrix(-0.652 -0.7583 0.7583 -0.652 366.0781 -7713.9448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6687FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07395926,
    style: {
      stopColor: "#6687FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5233,
    style: {
      stopColor: "#6687FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9305,
    style: {
      stopColor: "#6687FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#6687FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M600.7,486.2c174.6,23.7,186.7,101.5,186.9,121.3c-5.2,14-10.4,28.1-15.6,42.1 c-20.8,32.5-93.3,60.4-131.6-18.4C626.4,602.2,616.3,548.7,600.7,486.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -6582.8682,
    y1: -4867.0957,
    x2: -5968.459,
    y2: -4871.5122,
    gradientTransform: "matrix(-0.652 -0.7583 0.7583 -0.652 366.0781 -7713.9448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005EE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    style: {
      stopColor: "#276EF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3509,
    style: {
      stopColor: "#497BF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4994,
    style: {
      stopColor: "#5E84FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    style: {
      stopColor: "#6687FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6858,
    style: {
      stopColor: "#6386FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#5881FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8362,
    style: {
      stopColor: "#467AF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9066,
    style: {
      stopColor: "#2D6FF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    style: {
      stopColor: "#0D62E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#005DE6"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M389.4,139.5L1000,32.6l-0.6,1.7c-0.4,1.1-0.8,2.2-1.2,3.3l-0.5,1.5l-1.3,3.5l-0.7,1.9L975,100.3 c-20.7,56-41.4,111.9-62,167.9c-26.5,71.8-53.1,143.6-79.6,215.5c-15.2,41.2-30.5,82.5-45.7,123.7 c-0.2-19.7-12.2-97.6-186.9-121.3C571.3,368.4,522.2,218.4,389.4,139.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -6274.6816,
    y1: -5055.271,
    x2: -5853.9619,
    y2: -5413.4814,
    gradientTransform: "matrix(-0.652 -0.7583 0.7583 -0.652 366.0781 -7713.9448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#094FED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2426,
    style: {
      stopColor: "#0A4EEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#0D4CDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    style: {
      stopColor: "#1147CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8406,
    style: {
      stopColor: "#1841B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F3B99"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M87.4,192.3l301.9-52.8c132.8,79,181.9,228.9,211.3,346.7C518.1,475,434.9,468,351.9,460 c-3.8-0.4-7.7-0.7-11.5-1.1c-33.5-65.5-76.9-127.1-126.8-178.7c-8.9-9.2-18.1-18.1-27.8-26.5C185.8,253.7,130.1,205.2,87.4,192.3z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -5833.728,
    y1: -5500.606,
    x2: -6110.1206,
    y2: -5265.2788,
    gradientTransform: "matrix(-0.652 -0.7583 0.7583 -0.652 366.0781 -7713.9448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#365CE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05569615,
    style: {
      stopColor: "#325AE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    style: {
      stopColor: "#1749BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    style: {
      stopColor: "#063FA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#003B99"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M87.6,192.3c42.7,12.9,98.2,61.4,98.2,61.4c9.7,8.4,18.9,17.3,27.8,26.5 c49.9,51.6,93.3,113.2,126.8,178.7c-71.9-6.7-146.2-11.7-216.4-28.7C67.5,416.6,18.8,381.1,3.7,322.8 c-12.1-46.7,5.7-91.9,47.7-116.3c11.2-6.5,23.5-11.1,36.1-14.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.25517a0c2161252873128701fcf17c06.svg";
export { ForwardRef as ReactComponent };